// Guide content configuration
// This file contains all guide content organized by page/module

export const guideContent = {
    // Patients module
    patients: {
        title: 'Gestion des Patients',
        videoUrl: '', // YouTube embed URL to be added
        introduction: 'Guide de gestion des patients',
        steps: [
            {
                title: 'Ajouter un patient',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Consultations module
    consultations: {
        title: 'Gestion des Consultations',
        videoUrl: '',
        introduction: 'Guide de gestion des consultations',
        steps: [
            {
                title: 'Creer une consultation',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Calendar module
    calendar: {
        title: 'Calendrier des Rendez-vous',
        videoUrl: '',
        introduction: 'Guide du calendrier',
        steps: [
            {
                title: 'Ajouter un rendez-vous',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Ordonnances module
    ordonnances: {
        title: 'Gestion des Ordonnances',
        videoUrl: '',
        introduction: 'Guide des ordonnances',
        steps: [
            {
                title: 'Creer une ordonnance',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Products management module
    products: {
        title: 'Gestion des Produits et Materiels',
        videoUrl: '',
        introduction: 'Guide de gestion des produits',
        steps: [
            {
                title: 'Ajouter un produit',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Stock module
    stock: {
        title: 'Gestion du Stock',
        videoUrl: '',
        introduction: 'Guide de gestion du stock',
        steps: [
            {
                title: 'Consulter le stock',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Treatments module
    treatments: {
        title: 'Gestion des Traitements',
        videoUrl: '',
        introduction: 'Guide des traitements',
        steps: [
            {
                title: 'Ajouter un traitement',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Users module
    users: {
        title: 'Gestion des Utilisateurs',
        videoUrl: '',
        introduction: 'Guide de gestion des utilisateurs',
        steps: [
            {
                title: 'Ajouter un utilisateur',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Dashboard module
    dashboard: {
        title: 'Tableau de Bord',
        videoUrl: '',
        introduction: 'Guide du tableau de bord',
        steps: [
            {
                title: 'Consulter les statistiques',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Revenues module
    revenues: {
        title: 'Recettes',
        videoUrl: '',
        introduction: 'Guide des recettes',
        steps: [
            {
                title: 'Consulter les recettes',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },

    // Purchases module
    purchases: {
        title: 'Achats',
        videoUrl: '',
        introduction: 'Guide des achats',
        steps: [
            {
                title: 'Creer une commande',
                content: 'Contenu a venir...',
            },
        ],
        tips: [],
        warnings: [],
    },
}

// Map route keys to guide content keys
export const pageHelpMapping = {
    patients: 'patients',
    consultations: 'consultations',
    calendar: 'calendar',
    ordonnances: 'ordonnances',
    products: 'products',
    stock: 'stock',
    treatments: 'treatments',
    users: 'users',
    dashboard: 'dashboard',
    revenues: 'revenues',
    purchases: 'purchases',
}

// Get help content for a specific page
export const getHelpContent = (pageKey) => {
    const contentKey = pageHelpMapping[pageKey] || pageKey
    return guideContent[contentKey] || null
}
